module.exports = __webpack_public_path__ + "static/thumbVideo-55de237a0d52b49ec550060efe889d68.png";